export enum FleetVehicleStatus {
	ACTIVE = "Active",
	DEACTIVATED = "Deactivated"
}

export const FLEET_STATUS_LABELS: Record<FleetVehicleStatus, string> = {
	[FleetVehicleStatus.ACTIVE]: "Active",
	[FleetVehicleStatus.DEACTIVATED]: "Deactivated"
};

// Filter options for fleet status (includes "All fleet" option)
export const FLEET_STATUS_FILTER_OPTIONS = {
	ALL_FLEET: "All fleet",
	...FleetVehicleStatus
} as const;

export type FleetStatusFilterOption =
	(typeof FLEET_STATUS_FILTER_OPTIONS)[keyof typeof FLEET_STATUS_FILTER_OPTIONS];

export const DEFAULT_FLEET_STATUS_FILTER = FLEET_STATUS_FILTER_OPTIONS.ACTIVE;
